/**
 * @generated SignedSource<<89a0574b6c53b22b469f9e59c554a870>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type RoutineScheduleType = "DAILY" | "MONTHLY" | "WEEKLY";
import { FragmentRefs } from "relay-runtime";
export type WidgetTeamScheduleContentList_teamSchedule$data = {
  readonly events: ReadonlyArray<{
    readonly id: string;
    readonly routine?: {
      readonly description: string | null;
      readonly descriptionImages: ReadonlyArray<{
        readonly id: string;
      }>;
      readonly id: string;
    };
    readonly startAt: string;
    readonly taskExecution?: {
      readonly routine: {
        readonly description: string | null;
        readonly descriptionImages: ReadonlyArray<{
          readonly id: string;
        }>;
        readonly id: string;
      } | null;
    };
    readonly " $fragmentSpreads": FragmentRefs<"WidgetTeamScheduleListItem_item" | "useWidgetTeamScheduleSubscription_TeamScheduleEventOccasion">;
  }>;
  readonly freq: RoutineScheduleType;
  readonly id: string;
  readonly label: string;
  readonly " $fragmentType": "WidgetTeamScheduleContentList_teamSchedule";
};
export type WidgetTeamScheduleContentList_teamSchedule$key = {
  readonly " $data"?: WidgetTeamScheduleContentList_teamSchedule$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetTeamScheduleContentList_teamSchedule">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Routine",
    "kind": "LinkedField",
    "name": "routine",
    "plural": false,
    "selections": [
      (v0/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Image",
        "kind": "LinkedField",
        "name": "descriptionImages",
        "plural": true,
        "selections": [
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetTeamScheduleContentList_teamSchedule",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "freq",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "includeInlineRoutines",
          "value": true
        }
      ],
      "concreteType": null,
      "kind": "LinkedField",
      "name": "events",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startAt",
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v1/*: any*/),
          "type": "RoutineOccasion",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TaskExecutionCheck",
              "kind": "LinkedField",
              "name": "taskExecution",
              "plural": false,
              "selections": (v1/*: any*/),
              "storageKey": null
            }
          ],
          "type": "TeamScheduleInlineRoutineOccasion",
          "abstractKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "useWidgetTeamScheduleSubscription_TeamScheduleEventOccasion"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WidgetTeamScheduleListItem_item"
        }
      ],
      "storageKey": "events(includeInlineRoutines:true)"
    }
  ],
  "type": "TeamSchedule",
  "abstractKey": null
};
})();

(node as any).hash = "f729a2a905513400318cf7b51270e7d1";

export default node;
